import type { IBenefit } from "@/api/interfaces/benefitLayouts";

const getBusinessByExtID = (
  businesses: IBenefit[],
  extID: string,
): IBenefit | null =>
  businesses.find((business) => business.externalID === extID) || null;

export { getBusinessByExtID };
